/**
 * A document line has a quantity, a unit price and a value (quantity x unit price). People work from either end: a vendor's
 * invoice prints the unit price, a total is sometimes all they have. Typing one fills in the other from the quantity, and
 * the field typed last is the one that stays as typed: a later change of quantity keeps the unit price when that was typed
 * last, else keeps the value. Only the value is saved (to the paisa); the unit price is worked out from it again on opening.
 */
const num = (v) => {
  const n = parseFloat(v);
  return Number.isNaN(n) ? 0 : n;
};
const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

/** quantity x unit price in rupees and paise, '' when either is missing */
export function amountFromRate(quantity, unitPrice) {
  if (num(quantity) <= 0 || unitPrice === '' || unitPrice == null) return '';
  return round2(num(quantity) * num(unitPrice)).toFixed(2);
}

/** value / quantity to at most 4 decimals, no trailing zeros, '' when either is missing */
export function rateFromAmount(quantity, amount) {
  if (num(quantity) <= 0 || amount === '' || amount == null) return '';
  return String(Number((num(amount) / num(quantity)).toFixed(4)));
}

/**
 * What a change to one of a line's quantity, unitPrice or value does to the line: the fields to set (the line remembers which
 * of unitPrice and the value was typed last in `driver`). The value's field is `amountKey`: taxableAmount on a vendor invoice,
 * amount on a slip.
 */
export function lineEdit(line, field, value, amountKey = 'taxableAmount') {
  if (field === 'unitPrice') {
    const patch = { unitPrice: value, driver: 'rate' };
    const amount = amountFromRate(line.quantity, value);
    if (amount !== '') patch[amountKey] = amount;
    return patch;
  }
  if (field === amountKey) {
    return { [amountKey]: value, driver: 'taxable', unitPrice: rateFromAmount(line.quantity, value) };
  }
  // quantity
  const patch = { quantity: value };
  if (line.driver === 'rate' && line.unitPrice !== '' && line.unitPrice != null) {
    const amount = amountFromRate(value, line.unitPrice);
    if (amount !== '') patch[amountKey] = amount;
  } else if (line[amountKey] !== '' && line[amountKey] != null) {
    patch.unitPrice = rateFromAmount(value, line[amountKey]);
  }
  return patch;
}
